(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-real-life"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-hal-instagram]';

    function warm(video) {
      if (!video || video.dataset.halInstagramWarmed === 'true') return;
      video.dataset.halInstagramWarmed = 'true';
      video.preload = 'metadata';
      video.load();
    }

    function pause(card, reset) {
      const video = card.querySelector('video');
      if (!video) return;
      video.pause();
      if (reset) {
        try { video.currentTime = 0; } catch (error) {}
      }
      card.classList.remove('is-playing');
      const button = card.querySelector('[data-hal-instagram-play]');
      if (button) button.setAttribute('aria-pressed', 'false');
    }

    function play(card) {
      const video = card.querySelector('video');
      if (!video) return;
      warm(video);
      const promise = video.play();
      const markPlaying = () => {
        card.classList.add('is-playing');
        const button = card.querySelector('[data-hal-instagram-play]');
        if (button) button.setAttribute('aria-pressed', 'true');
      };
      if (promise) {
        promise.then(markPlaying).catch(() => pause(card, false));
      } else {
        markPlaying();
      }
    }

    function init(root) {
      if (!root || root.dataset.halInstagramReady === 'true') return;
      root.dataset.halInstagramReady = 'true';
      const cards = root.querySelectorAll('[data-hal-instagram-card]');
      const rail = root.querySelector('.hal-instagram__rail');
      const previousButton = root.querySelector('[data-hal-instagram-prev]');
      const nextButton = root.querySelector('[data-hal-instagram-next]');
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth > 767;

      if (rail && previousButton && nextButton) {
        const updateNavigation = () => {
          const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
          const hasOverflow = maxScroll > 2;
          root.classList.toggle('has-overflow', hasOverflow);
          previousButton.disabled = !hasOverflow || rail.scrollLeft <= 2;
          nextButton.disabled = !hasOverflow || rail.scrollLeft >= maxScroll - 2;
        };
        const scrollOneCard = (direction) => {
          const firstCard = rail.querySelector('[data-hal-instagram-card]');
          if (!firstCard) return;
          const gap = parseFloat(getComputedStyle(rail).gap) || 0;
          rail.scrollBy({ left: direction * (firstCard.getBoundingClientRect().width + gap), behavior: 'smooth' });
        };
        previousButton.addEventListener('click', () => scrollOneCard(-1));
        nextButton.addEventListener('click', () => scrollOneCard(1));
        rail.addEventListener('scroll', updateNavigation, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(updateNavigation).observe(rail);
        requestAnimationFrame(updateNavigation);
      }

      cards.forEach((card) => {
        const video = card.querySelector('video');
        const button = card.querySelector('[data-hal-instagram-play]');
        const media = card.querySelector('.hal-instagram__media');
        if (!video) return;
        video.muted = true;
        video.playsInline = true;

        if (canHover) {
          card.addEventListener('mouseenter', () => play(card));
          card.addEventListener('mouseleave', () => pause(card, true));
        } else if (button) {
          const toggle = () => {
            cards.forEach((otherCard) => { if (otherCard !== card) pause(otherCard, false); });
            if (video.paused) play(card); else pause(card, false);
          };
          button.setAttribute('aria-pressed', 'false');
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            toggle();
          });
          if (media) media.addEventListener('click', toggle);
        }
      });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            warm(entry.target.querySelector('video'));
          } else {
            pause(entry.target, false);
          }
        });
      }, { threshold: 0.05, rootMargin: '300px 0px' });
      cards.forEach((card) => observer.observe(card));
    }

    document.querySelectorAll(selector).forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector(selector)));
  })();

  } catch(e) { console.error(e); }
})();
})();
